import React from 'react';
import Faqs from '../components/faqscomponent';
import '../styles/faqs.css';

function FaqsPage() {
  return (
    <section className="contact-page">
      <div className="container contact-page-inner">
        <Faqs />
      </div>
    </section>
  );
}

export default FaqsPage;
